import { Dispatch, SetStateAction, createContext } from "react";
import { Option } from "./ListView";

/**
 * Context properties for the ListView component
 */
export type ListViewContextProps = {
  /** Array of option objects for focus management */
  options?: Option[];
  /** Callback when selection changes */
  onSelectionChange?: (value: unknown[]) => void;
  /** Currently selected items */
  selectedItems: unknown[];
  /** Currently indeterminate items */
  indeterminateItems: unknown[];
  /** Array of items if using items prop */
  items?: unknown[];
  /** Function to set the selected items */
  setSelectedItems: Dispatch<
    SetStateAction<ListViewContextProps["selectedItems"]>
  >;
  /** Whether the component is controlled */
  controlled?: boolean;
};

export const ListViewContext = createContext<ListViewContextProps | null>(null);
